import { defineStore } from "pinia";
import { computed, ref } from "vue";
import ApiTags from "@/apis/ApiTags";
import { exceptionWrapper, useTableData } from "./piniaUtils";

export const useTagsStore = defineStore("tags", () => {
  const tags = ref([]);
  const { table, resetPage } = useTableData();
  const loading = ref(true);
  const error = ref(false);

  const renderLength = computed(() => {
    const dataLength = tags.value?.length || 0;
    return Math.min(dataLength, (table.page || 1) * table.perPage);
  });

  const loadTable = (next = false) => {
    if (next) return (table.page += 1);
    table.totalCount = tags.value.length;
    table.totalPages = ~~(table.totalCount / table.perPage);
  };

  const getTags = appId =>
    exceptionWrapper(
      async () => {
        resetPage();
        table.page = 1;
        table.perPage = 50;
        table.totalCount = tags.value?.length || 55;
        tags.value = await ApiTags.getTags(appId);
        loadTable();
      },
      { loading, error, toast: true },
    );

  const createTag = (appId, tag) =>
    exceptionWrapper(
      async () => {
        const tagRes = await ApiTags.createTag(appId, tag);
        tags.value = [tagRes, ...tags.value];
        loadTable();
        return tagRes;
      },
      { loading, error, toast: true },
    );

  const deleteTag = (appId, tagId) =>
    exceptionWrapper(
      async () => {
        ApiTags.deleteTag(appId, tagId);
        tags.value = tags.value.filter(el => el.id !== tagId);
        loadTable();
        if (table.page > table.totalPages) table.page = table.totalPages;
      },
      { loading, error, toast: true },
    );

  const editTag = (appId, tag) =>
    exceptionWrapper(
      async () => {
        const tagRes = await ApiTags.updateTag(appId, tag);
        const index = tags.value.findIndex(t => t.id === tagRes.id); // Find and update the existing tag in the array
        tags.value.splice(index, 1, tagRes); // Replace the existing tag

        loadTable();

        return tagRes;
      },
      { loading, error, toast: true },
    );

  return {
    table,
    getTags,
    createTag,
    deleteTag,
    editTag,
    tags,
    loading,
    error,
    loadTable,
    renderLength,
  };
});
